
document.addEventListener("DOMContentLoaded", () => {
  createAppOpt();

  let allCheckboxes = document.querySelectorAll("input[type='checkbox']");
  allCheckboxes.forEach((cb) => {
    cb.value = "F";
    cb.addEventListener("click", (e) => {
      let value = e.target.value;
      e.target.value = value === "T" ? "F" : "T";
    });
  });

  let submitButton = document.querySelector("#submitButton");

  submitButton.addEventListener("click", (e) => {
    try {
      e.preventDefault();
      let getForm = document.querySelector("#form-container");
      let formCont = document.getElementById("form-container");
      const iframe = document.querySelector('iframe[name="tcsResponse"]');

      let isValid = ctgFormValidate(getForm);
      console.log("is valid ", isValid);
      if (isValid) {
        if (iframe) {
          iframe.style.display = "block";
          iframe.style.visibility = "visible";
          iframe.style.height = "400px";
          iframe.style.width = "100%";

          getForm.style.display = "none";

          const loadingMsg = document.createElement("div");
          loadingMsg.className = "form-loading-message";

          getForm.parentNode.insertBefore(loadingMsg, iframe);
        }
        formCont.style.height = "300px";
        if (formCont) {
          const y = formCont.getBoundingClientRect().top + window.scrollY - 150;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else {
          console.warn(".newCustomForm not found");
        }
        let getLoadingMsg = document.querySelector(".form-loading-message");

        getForm.submit();
        submitButton.disabled = false;

        const headerHeight = document
          .getElementById("shopify-section-header")
          .getBoundingClientRect().height;
        const imageHeader = document.querySelector(".imageHeader");
        const targetY =
          imageHeader.getBoundingClientRect().top +
          window.scrollY -
          headerHeight;

        window.scrollTo({
          top: targetY,
          behavior: "smooth",
        });
      }else{
        const headerHeight = document
          .getElementById("shopify-section-header")
          .getBoundingClientRect().height;
        const imageHeader = document.querySelector(".imageHeader");
        const targetY =
          imageHeader.getBoundingClientRect().top +
          window.scrollY -
          headerHeight;

        window.scrollTo({
          top: targetY,
          behavior: "smooth",
        });
      }
    } catch (e) {
      throw e;
    }
  });
});


function createAppOpt() {
  let options = [
    { "name": "Refrigerator", "id": "custentity_refrigerator_w_h_d_m" },
    { "name": "Dishwasher", "id": "custentity_dishwasher_w_h_d_m" },
    { "name": "Microwave", "id": "custentity_microwave_w_h_d_m" },
    { "name": "Stove", "id": "custentity_stove_w_h_d_m" },
    { "name": "Wall Oven", "id": "custentity_wall_oven_w_h_d_m" },
    { "name": "Oven Hood", "id": "custentity_oven_hood_w_h_d_m" },
    { "name": "Sink", "id": "custentity_sink_w_h_d_m" },
    { "name": "Other", "id": "custentity_other_w_h_d_m" }
  ]

  options.forEach(opt => {
    let diaOpts = ['Width: ', 'Height: ', 'Depth: ', 'Model #: ']
    let getContainer = document.querySelector('.appliance-opt-cont')

    let createOptCont = document.createElement('div')
    createOptCont.classList = 'appliance-opt'

    let submitInput = document.createElement('input')
    submitInput.type = 'hidden'
    submitInput.value = ''
    submitInput.name = opt.id
    submitInput.id = opt.name.toLocaleLowerCase().replace(' ', '-') + '-input'
    createOptCont.appendChild(submitInput)

    let createHeader = document.createElement('div')
    createHeader.classList = 'opt-name'
    createHeader.innerHTML = opt.name
    createOptCont.appendChild(createHeader)

    let allDiaCont = document.createElement('div')
    allDiaCont.classList = 'all-dia-cont'

    // store references to the 4 inputs so we can read them all at once
    let fieldInputs = { w: null, h: null, d: null, m: null }

    diaOpts.forEach(item => {

      let createDiaCont = document.createElement('div')
      createDiaCont.classList = 'diaCont'

      let key = item.slice(0, 1).toLocaleLowerCase() // 'w', 'h', 'd', 'm'

      let createLabel = document.createElement('label')
      createLabel.htmlFor = opt.name.toLocaleLowerCase().replace(' ', '-') + "-" + key
      createLabel.innerHTML = item

      let createInput = document.createElement('input')
      createInput.type = 'text'
      createInput.name = opt.name.toLocaleLowerCase().replace(' ', '-') + "-" + key
      createInput.id = opt.name.toLocaleLowerCase().replace(' ', '-') + "-" + key

      // save reference
      fieldInputs[key] = createInput

      // update the hidden submitInput whenever any of the 4 fields change
      createInput.addEventListener('input', () => {
        let w = fieldInputs.w.value.trim()
        let h = fieldInputs.h.value.trim()
        let d = fieldInputs.d.value.trim()
        let m = fieldInputs.m.value.trim()

        submitInput.value = `${w} W x ${h} H x ${d} D | model: ${m}`
      })

      createDiaCont.appendChild(createLabel)
      createDiaCont.appendChild(createInput)

      allDiaCont.appendChild(createDiaCont)
    })

    createOptCont.appendChild(allDiaCont)

    getContainer.appendChild(createOptCont)

  })

}


/**
 *    form validation
 */
function ctgFormValidate(ctgData) {
  let fails = 0;
  let failMessage = "Please correct all highlighted fields.";

  const sanitizer = new Sanitizer();
  sanitizer.removeUnsafe()
  function sanitize(valueDiv){
      let value = valueDiv.value
      const scratch = document.createElement('div');
      scratch.setHTML(value, { sanitizer });
      let clean = scratch.innerHTML
      valueDiv.value = clean.trim()
      // console.log("valueDiv ", valueDiv.value)
  }

  function validateField(item){
      if(item.value != ''){
          sanitize(item)
      }
      if(item.value == ''){
          fails++;
          item.classList.add("failed");
          return false
      }else{
          item.classList.remove("failed"); 
      }
  }

  validateField(ctgData["firstname"]);
  validateField(ctgData["lastname"]);
  validateField(ctgData["phone"]);
  validateField(ctgData["address"]);
  validateField(ctgData["city"]);
  sanitize(ctgData['custentity_tcs_referral_samples_taken'])
  // tcs employee
  sanitize(ctgData['custentity_tcs_employee_name'])
  sanitize(ctgData['custentity_tcs_employee_id'])
  // Project
  sanitize(ctgData['custentity_project_fs'])
  // flooring
  sanitize(ctgData['custentity_flooring_area'])
  sanitize(ctgData['custentity_floor_type'])
  sanitize(ctgData['custentity_floor_sq_ft'])
  sanitize(ctgData['custentity_flooring_sub_floor'])
  sanitize(ctgData['custentity_flooring_mat'])
  // cabinets
  sanitize(ctgData['custentity_cabinets_other'])
  sanitize(ctgData['custentity_cabinet_color'])
  sanitize(ctgData['custentity_door_style'])
  sanitize(ctgData['custentity_species'])
  sanitize(ctgData['custentity_ceiling_height'])
  sanitize(ctgData['custentity_cabinet_height_other'])
  // appliance 
  sanitize(ctgData['custentity_refrigerator_w_h_d_m'])
  sanitize(ctgData['custentity_dishwasher_w_h_d_m'])
  sanitize(ctgData['custentity_microwave_w_h_d_m'])
  sanitize(ctgData['custentity_stove_w_h_d_m'])
  sanitize(ctgData['custentity_wall_oven_w_h_d_m'])
  sanitize(ctgData['custentity_oven_hood_w_h_d_m'])
  sanitize(ctgData['custentity_sink_w_h_d_m'])
  sanitize(ctgData['custentity_other_w_h_d_m'])

  let emailValue = ctgData["email"].value
  if (emailValue != null || emailValue != '') {
      let isValid =  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
      if (isValid) {
          ctgData["email"].classList.remove("failed");
      } else {
          fails++;
          ctgData["email"].classList.add("failed");
          return false
      }
  }


  let zipValue = ctgData["zipcode"].value;
  console.log('zipcode ', zipValue)
  if (zipValue != null || zipValue != '') {
      let isValid = /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipValue);
      if (isValid) {
          ctgData["zipcode"].classList.remove("failed");
      } else {
        console.log('failed')
          fails++;
          ctgData["zipcode"].classList.add("failed");
          return false
      }
  }

  let phoneValue = ctgData["phone"].value
  if (phoneValue != null || phoneValue != "") {
      const re = /^(\(\d{3}\)\s*\d{3}-\d{4}|\d{10}|\d{3}-\d{3}-\d{4})$/;
      let testRes = re.test(phoneValue);
      if (testRes) {
          ctgData["phone"].classList.remove("failed");
      } else {
          fails++;
          ctgData["phone"].classList.add("failed");
          return false
      }
  }


  const ctgFormMessageElement =
    ctgData.getElementsByClassName("etcFormMessage")[0];

  if (fails > 0) {
    if (ctgFormMessageElement) {
      ctgFormMessageElement.innerHTML = failMessage;
      ctgFormMessageElement.style.color = "#fa725b";
    }
    console.log("Form validation failed with " + fails + " errors.");
    return false;
  } else {
    if (ctgFormMessageElement) {
      ctgFormMessageElement.innerHTML = "";
      ctgFormMessageElement.style.color = "";
    }
    return true;
  }
}

function validateCTGEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function validateCTGZip(zip) {
  return /^[0-9]{5}$/.test(zip);
}

function validateCTGPhone(phone) {
  const cleanedPhone = phone.replace(/\D/g, "");
  return cleanedPhone.length === 10;
}

const sanitizer = new Sanitizer();
sanitizer.removeUnsafe()
function sanitize(valueDiv){
    let value = valueDiv.value
    const scratch = document.createElement('div');
    scratch.setHTML(value, { sanitizer });
    let clean = scratch.innerHTML
    valueDiv.value = clean.trim()
    // console.log("valueDiv ", valueDiv.value)
}

function validateField(item){
    if(item.value != ''){
        sanitize(item)
    }
    if(item.value == ''){
        fails++;
        item.classList.add("failed");
        return false
    }else{
        item.classList.remove("failed"); 
    }
}
